var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoonbeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6056 4.83826C10.8205 4.83826 8.53344 7.02646 8.28752 9.81907C8.2633 10.0941 8.48948 10.3187 8.76562 10.3187H18.4455C18.7216 10.3187 18.9478 10.0941 18.9236 9.81907C18.6777 7.02646 16.3906 4.83826 13.6056 4.83826Z",
    fill: "#53CBC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8474 11.9609C20.0239 11.9609 20.167 11.8178 20.167 11.6413C20.167 11.4648 20.0239 11.3217 19.8474 11.3217L7.49945 11.3217C7.32292 11.3217 7.17981 11.4648 7.17981 11.6413C7.17981 11.8178 7.32292 11.9609 7.49945 11.9609L19.8474 11.9609Z",
    fill: "#E1147B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9572 13.4244C14.1337 13.4244 14.2769 13.2813 14.2769 13.1048C14.2769 12.9283 14.1337 12.7852 13.9572 12.7852L4.98029 12.7852C4.80376 12.7852 4.66065 12.9283 4.66065 13.1048C4.66065 13.2813 4.80376 13.4244 4.98029 13.4244H13.9572Z",
    fill: "#E1147B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2919 14.8877C18.4684 14.8877 18.6115 14.7446 18.6115 14.5681C18.6115 14.3915 18.4684 14.2484 18.2919 14.2484H7.49951C7.32298 14.2484 7.17987 14.3915 7.17987 14.5681C7.17987 14.7446 7.32298 14.8877 7.49951 14.8877H18.2919Z",
    fill: "#E1147B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89823 16.3509C10.0748 16.3509 10.2179 16.2078 10.2179 16.0313C10.2179 15.8548 10.0748 15.7117 9.89823 15.7117H5.61702C5.44049 15.7117 5.29738 15.8548 5.29738 16.0313C5.29738 16.2078 5.44049 16.3509 5.61702 16.3509H9.89823Z",
    fill: "#E1147B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4953 17.8142C18.6719 17.8142 18.815 17.6711 18.815 17.4946C18.815 17.318 18.6719 17.1749 18.4953 17.1749H12.9898C12.8133 17.1749 12.6702 17.318 12.6702 17.4946C12.6702 17.6711 12.8133 17.8142 12.9898 17.8142H18.4953Z",
    fill: "#E1147B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1654 19.2775C15.3419 19.2775 15.485 19.1344 15.485 18.9578C15.485 18.7813 15.3419 18.6382 15.1654 18.6382H9.65988C9.48335 18.6382 9.34024 18.7813 9.34024 18.9578C9.34024 19.1344 9.48335 19.2775 9.65988 19.2775H15.1654Z",
    fill: "#E1147B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0954 16.3509C20.2719 16.3509 20.415 16.2078 20.415 16.0313C20.415 15.8548 20.2719 15.7117 20.0954 15.7117H11.2244C11.0478 15.7117 10.9047 15.8548 10.9047 16.0313C10.9047 16.2078 11.0478 16.3509 11.2244 16.3509H20.0954Z",
    fill: "#E1147B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02795 11.64C6.02795 11.4642 6.17049 11.3217 6.34631 11.3217C6.52214 11.3217 6.66467 11.4642 6.66467 11.64C6.66467 11.8158 6.52214 11.9584 6.34631 11.9584C6.17049 11.9584 6.02795 11.8158 6.02795 11.64Z",
    fill: "#E1147B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50879 13.1035C3.50879 12.9277 3.65132 12.7852 3.82715 12.7852C4.00297 12.7852 4.14551 12.9277 4.14551 13.1035C4.14551 13.2793 4.00297 13.4219 3.82715 13.4219C3.65132 13.4219 3.50879 13.2793 3.50879 13.1035Z",
    fill: "#E1147B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02795 14.5668C6.02795 14.3909 6.17049 14.2484 6.34631 14.2484C6.52214 14.2484 6.66467 14.3909 6.66467 14.5668C6.66467 14.7426 6.52214 14.8851 6.34631 14.8851C6.17049 14.8851 6.02795 14.7426 6.02795 14.5668Z",
    fill: "#E1147B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14551 16.03C4.14551 15.8542 4.28804 15.7117 4.46387 15.7117C4.63969 15.7117 4.78223 15.8542 4.78223 16.03C4.78223 16.2059 4.63969 16.3484 4.46387 16.3484C4.28804 16.3484 4.14551 16.2059 4.14551 16.03Z",
    fill: "#E1147B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5183 17.4933C11.5183 17.3175 11.6608 17.1749 11.8367 17.1749C12.0125 17.1749 12.155 17.3175 12.155 17.4933C12.155 17.6691 12.0125 17.8116 11.8367 17.8116C11.6608 17.8116 11.5183 17.6691 11.5183 17.4933Z",
    fill: "#E1147B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18835 18.9565C8.18835 18.7807 8.33089 18.6382 8.50671 18.6382C8.68254 18.6382 8.82507 18.7807 8.82507 18.9565C8.82507 19.1324 8.68254 19.2749 8.50671 19.2749C8.33089 19.2749 8.18835 19.1324 8.18835 18.9565Z",
    fill: "#E1147B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonbeam);
export default __webpack_public_path__ + "static/media/moonbeam.c16a518e47be85306e5ee3adc58f0c69.svg";
export { ForwardRef as ReactComponent };